import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
	selector: '[zerocolumns]'
})
export class ZeroColumnsDirective {
	@Input('zerocolumns') hideZeroColumns: boolean = true;

	constructor(private el: ElementRef) {}

	doWork() {
		let table = this.el.nativeElement;
		//let container = el.querySelector('ul');
		//debugger;
		//console.log('zerocolumns', table.tBodies[0].rows[0].cells[0].innerText);
		let arr = [];
		for (let tbody of table.tBodies) {
			//console.log(tbody.innerHTML);
			for (let row of tbody.rows) {
				let i = 0;
				if (arr.length == 0) {
					arr = Array(row.cells.length).fill(0);
				}
				for (let cell of row.cells) {
					//console.log(cell.innerText);

					let content = cell.innerText.trim();
					if (content != '0') {
						arr[i]++;
					}
					i++;
				}
			}
		}


		for (let tbody of table.tBodies) {
			for (let row of tbody.rows) {
				let i = 0;
				for (let cell of row.cells) {
					if (arr[i] == 0) {
						//cell.style.backgroundColor = '#ccffcc';
						cell.style.display = this.hideZeroColumns ? 'none' : '';
					}

					i++;
				}
			}
		}
		for (let row of table.tHead.rows) {
			let i = 0;
			for (let cell of row.cells) {
				if (arr[i] == 0) {
					//cell.style.backgroundColor = '#ccffcc';
					cell.style.display = this.hideZeroColumns ? 'none' : '';
				}

				i++;
			}
		}
		//console.log(arr);
	}

	ngOnChanges() {
		this.doWork();
	}

	ngAfterViewInit() {
		this.doWork();
	}
}
